var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gs-toolbar",attrs:{"role":"menu"},on:{"click":function($event){$event.stopPropagation();return _vm.onSelect($event)}}},[_vm._v(" "+_vm._s(_vm.displayName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }